import React, { useMemo, useState, useEffect } from 'react';
import { Line } from 'react-chartjs-2';
import { compose, withHandlers, withPropsOnChange } from "recompose";
import { range } from "lodash";
import { LocalForm, Control, actions } from "react-redux-form";
import {
  Page,
  onMount,
  FormGroup,
  DatePicker,
  SubmitButton,
} from "components/common";
import Select from "react-select";
import { Trans } from "react-i18next";
import { withOrganisationContextConsumer } from "contexts/OrganisationContext";
import { getMonthEnd, getMonthStart } from "../Xero/Reports/util";
import { useTranslation } from "react-i18next";
import { Col, Row } from "reactstrap";
import { withDefaultReportParams } from "../Xero/Reports/hooks/useDefaultReportParams";
import MainCard from './MainCard';

const trackingCategories = [];

const refreshChart = () => {
    window.location.reload();
  };
  

export const ProfitAndLoss = ({
  data,
  item: itemProp,
  handleSubmit,
  setState,
  timeframes,
  periods,
  settings,
  organisation,
  dispatch,
}) => {
    

  const { t } = useTranslation();
  const [item, setItem] = useState(itemProp);

  const findRowValue = (sections, targetValueName) => {
    for (const section of sections) {
      for (const row of section.Rows) {
        if (row.RowType === 'Row') {
          const valueName = row.Cells[0].Value;
          const values = row.Cells.slice(1).map(cell => cell.Value);
  
          if (valueName === targetValueName) {
            return { valueName, values };
          }
        }
      }
    }
    return { valueName: '', values: Array(12).fill('') };
  };
  
  const fetchData = (sections, targetValueName) => {
    const { valueName, values } = findRowValue(sections, targetValueName);
    return [valueName, ...values];
  };
  
  const sectionsWithEmptyTitle = data.Rows.filter(row => row.RowType === 'Section' && row.Title === '');
  
  const [
    grossProfitName,
    grossProfitValue1,
    grossProfitValue2,
    grossProfitValue3,
    grossProfitValue4,
    grossProfitValue5,
    grossProfitValue6,
    grossProfitValue7,
    grossProfitValue8,
    grossProfitValue9,
    grossProfitValue10,
    grossProfitValue11,
    grossProfitValue12,
  ] = fetchData(sectionsWithEmptyTitle, 'Gross Profit');
  
  const [
    netProfitName,
    netProfitValue1,
    netProfitValue2,
    netProfitValue3,
    netProfitValue4,
    netProfitValue5,
    netProfitValue6,
    netProfitValue7,
    netProfitValue8,
    netProfitValue9,
    netProfitValue10,
    netProfitValue11,
    netProfitValue12,
  ] = fetchData(sectionsWithEmptyTitle, 'Net Profit');
  
  console.log(netProfitValue9);
  console.log(grossProfitValue3);
  
  
  console.log(grossProfitName, grossProfitValue11);
  console.log(netProfitName, netProfitValue12);

  const getSummaryHeader = (data, n) => {
    const section = data.Rows.find(row => row.RowType === 'Header');
    return section?.Cells[n]?.Value;
  };
  
  const headers = Array.from({ length: 13 }, (_, index) => getSummaryHeader(data, index));

  const extractWords = (str) => {
    if (str && typeof str === 'string') {
      return str.substring(3);
    }
    return ''; 
  };

  const extractWordss = (str) => {
    if (str && typeof str === 'string') {
      const wordsArray = str.replace(/^\d+/, '').match(/[a-zA-Z]+/g);
      return wordsArray ? wordsArray.join(' ') : '';
    }
    return ''; 
  };
  
  
  const header5 = extractWords(headers[10]);
  
  console.log("Jan:", extractWords(headers[12]))
  console.log("Mar:", header5)
  
  const getSummaryCellValue = (data, sectionTitle, n) => {
    const section = data.Rows.find(row => row.RowType === 'Section' && row.Title === sectionTitle);
    const summaryRow = section?.Rows.find(row => row.RowType === 'SummaryRow');
    
    return summaryRow ? summaryRow.Cells[n]?.Value : undefined;
  };
  
  const otherInc = Array.from({ length: 13 }, (_, index) => getSummaryCellValue(data, "Plus Other Income", index));
  const income = Array.from({ length: 13 }, (_, index) => getSummaryCellValue(data, "Income", index));
  const expensesLess = Array.from({ length: 13 }, (_, index) => getSummaryCellValue(data, "Less Operating Expenses", index));
  
  const [incomeName, 
    incomeNumber1, 
    incomeNumber2, 
    incomeNumber3, 
    incomeNumber4, 
    incomeNumber5, 
    incomeNumber6, 
    incomeNumber7, 
    incomeNumber8, 
    incomeNumber9, 
    incomeNumber10, 
    incomeNumber11, 
    incomeNumber12] = income;
  
  const [expensesLessName, 
    expensesLessValue1, 
    expensesLessValue2, 
    expensesLessValue3, 
    expensesLessValue4, 
    expensesLessValue5, 
    expensesLessValue6, 
    expensesLessValue7, 
    expensesLessValue8, 
    expensesLessValue9, 
    expensesLessValue10, 
    expensesLessValue11, 
    expensesLessValue12,] = expensesLess;
  
  const [otherIncName, otherIncNumber1, otherIncNumber2, otherIncNumber3, otherIncNumber4, otherIncNumber5, otherIncNumber6] = otherInc;

const filterData = (data) => data.filter(item => item.value != null);
const generateData = (headers, values, valueExtractor) => {
  return filterData(values.map((value, index) => ({
    id: index + 1,
    month: extractWords(headers[12 - index]),
    value: valueExtractor(value),
  })));
};

const revenueData = generateData(
  headers,
  [incomeNumber12, 
    incomeNumber11, 
    incomeNumber10, 
    incomeNumber9, 
    incomeNumber8, 
    incomeNumber7, 
    incomeNumber6, 
    incomeNumber5, 
    incomeNumber4, 
    incomeNumber3, 
    incomeNumber2, 
    incomeNumber1],
    (value) => value
);

const expensesData = generateData(
  headers,
  [expensesLessValue12, 
    expensesLessValue11, 
    expensesLessValue10, 
    expensesLessValue9, 
    expensesLessValue8, 
    expensesLessValue7, 
    expensesLessValue6, 
    expensesLessValue5, 
    expensesLessValue4, 
    expensesLessValue3, 
    expensesLessValue2, 
    expensesLessValue1],
    (value) => value
);

const grossProfit = generateData(
  headers,
  [grossProfitValue12, 
    grossProfitValue11, 
    grossProfitValue10, 
    grossProfitValue9, 
    grossProfitValue8,
    grossProfitValue7, 
    grossProfitValue6, 
    grossProfitValue5,
    grossProfitValue4,
    grossProfitValue3,
    grossProfitValue2, 
    grossProfitValue1],
    (value) => value
);

const netProfit = generateData(
  headers,
  [netProfitValue12, 
    netProfitValue11, 
    netProfitValue10, 
    netProfitValue9,
    netProfitValue8, 
    netProfitValue7, 
    netProfitValue6, 
    netProfitValue5, 
    netProfitValue4, 
    netProfitValue3, 
    netProfitValue2, 
    netProfitValue1],
    (value) => value
);



const [profitLossChartData, setProfitLossChartData] = useState({});


  const convertTableToChartData = (tableData, labelKey, dataKey, chartType) => {
    const labels = tableData.map((item) => item[labelKey]);
    const data = tableData.map((item) => item[dataKey]);
  
    if (chartType === 'bubble' || chartType === 'scatter') {
      const datasets = [
        {
          label: 'Chart Data',
          data: data.map((value, index) => ({ x: index + 1, y: value })),
          backgroundColor: getRandomColors(tableData.length),
          borderColor: 'rgba(75,192,192,1)',
          borderWidth: 1,
        },
      ];
  
      return {
        labels,
        datasets,
      };
    }
  
    return {
      labels,
      datasets: [
        {
          label: 'Chart Data',
          data,
          backgroundColor: chartType === 'doughnut' ? getRandomColors(tableData.length) : 'rgba(75,192,192,0.2)',
          borderColor: 'rgba(75,192,192,1)',
          borderWidth: 1,
        },
      ],
    };
  };
  
  useEffect(() => {
    const profitLossChart = convertTableToChartData(revenueData, 'month', 'value', 'line');    
  
    setProfitLossChartData(profitLossChart);

    
    const chartData = {
      labels: profitLossChart.labels,
      datasets: [
        {
          label: t('Revenue'),
          data: profitLossChart.datasets[0].data,
          borderColor: 'rgba(75, 192, 192, 1)',
          backgroundColor: 'rgba(75, 192, 192, 0.2)',
          borderWidth: 1,
        },
        {
          label: t('Expenses'),
          data: convertTableToChartData(expensesData, 'month', 'value', 'line').datasets[0].data,
          borderColor: 'rgba(255, 99, 132, 1)',
          backgroundColor: 'rgba(255, 99, 132, 0.2)',
          borderWidth: 1,
        },
        {
          label: t('Gross Profit'),
          data: convertTableToChartData(grossProfit, 'month', 'value', 'line').datasets[0].data,
          borderColor: 'rgba(255, 205, 86, 1)',
          backgroundColor: 'rgba(255, 205, 86, 0.2)',
          borderWidth: 1,
        },
        {
          label: t('Net Profit'),
          data: convertTableToChartData(netProfit, 'month', 'value', 'line').datasets[0].data,
          borderColor: 'rgba(54, 162, 235, 1)', 
          backgroundColor: 'rgba(54, 162, 235, 0.2)',
          borderWidth: 1,
        },
      ],
    };
  
    setProfitLossChartData(chartData);
  }, []);
  
  const getRandomColors = (count) => {
    const colors = [];
    for (let i = 0; i < count; i++) {
      const color = `rgba(${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, ${Math.floor(
        Math.random() * 256
      )}, 0.6)`;
      colors.push(color);
    }
    return colors;
  };

  const compareOptions = useMemo(
    () => [
      {
        label: t("Compare Periods"),
        value: "periods",
      },
      ...trackingCategories.map((i) => ({
        value: i.TrackingCategoryID,
        label: t("Compare {{ Name }}", i),
      })),
    ],
    [t, trackingCategories]
  );

  const { compare } = item;

  return (
    <Page title={t(data.ReportTitles[0])} printTitle={false} translate={false}>
        <div>
            <LocalForm
                className="d-print-none"
                getDispatch={(dispatch) => setState({ dispatch })}
                onSubmit={handleSubmit}
                onChange={setItem}
                initialState={item}
            >
                <Row form>
                <Col lg="auto">
                    <FormGroup label="From date">
                    <DatePicker model=".fromDate" className="form-control" />
                    </FormGroup>
                </Col>
                <Col lg="auto">
                    <FormGroup label="To date">
                    <DatePicker
                        style={{ width: "12rem" }}
                        model=".toDate"
                        className="form-control"
                    />
                    </FormGroup>
                </Col>
                {trackingCategories.length ? (
                    <Col lg="auto">
                    <FormGroup label="Compare" addControlClass={false}>
                        <Control.select
                        component={Select}
                        style={{ minWidth: "13rem" }}
                        options={compareOptions}
                        searchable={false}
                        simpleValue
                        clearable={false}
                        model=".compare"
                        />
                    </FormGroup>
                    </Col>
                ) : null}
                {compare === "periods" && (
                    <>
                    <Col lg="auto">
                        <FormGroup label="Periods" addControlClass={false}>
                        <Control.select
                            component={Select}
                            simpleValue
                            style={{ minWidth: "10rem" }}
                            options={periods}
                            clearable={false}
                            searchable={false}
                            model=".periods"
                        />
                        </FormGroup>
                    </Col>
                    <Col lg="auto">
                        <FormGroup label="Timeframe" addControlClass={false}>
                        <Control.select
                            component={Select}
                            simpleValue
                            clearable={false}
                            style={{ minWidth: "10rem" }}
                            options={timeframes}
                            searchable={false}
                            model=".timeframe"
                        />
                        </FormGroup>
                    </Col>
                    </>
                )}
                <Col lg="auto">
                    <FormGroup label="&nbsp;" className="mr-3">
                    <FormGroup label="Cash transactions only" check>
                        <Control.checkbox model=".paymentsOnly" />
                    </FormGroup>
                    </FormGroup>
                </Col>
                <Col lg="auto">
                    <FormGroup label="&nbsp;">
                    <SubmitButton size="sm" className="d-block">
                        Update
                    </SubmitButton>
                    </FormGroup>
                </Col>
                </Row>
            </LocalForm>
            <MainCard linkTo="/reports/profit_and_loss">
            <div className='my-4' style={{ gap: '20px' }}>
            {/* Profit and Loss */}
                <div style={{ flex: '1 1 400px' }}>
                    <h4><Trans>Profit and Loss of</Trans> {data?.ReportTitles[1]}</h4>
                    <Line data={profitLossChartData} options={{ maintainAspectRatio: true, responsive: true }} />
                </div>
            </div>
            </MainCard>
        </div>
    </Page>
  );
};

const loadReport = (item, xero) =>
  xero.get("reports/ProfitAndLoss", {
    params: {
      extra_params: item,
    },
  }).get("data");

export const enhance = compose(
  withOrganisationContextConsumer,
  withDefaultReportParams(() => ({
    fromDate: getMonthStart(),
    toDate: getMonthEnd(),
    periods: 5,
    compare: "periods",
    timeframe: "MONTH",
  })),
  onMount(({ xero, fetchSettings, fetchOrganisation, item }) => () => {
    return Promise.props({
      data: loadReport(
        {
          ...item,
          tracking_category:
            item.compare !== "periods" ? item.compare : undefined,
        },
        xero
      ),
      settings: fetchSettings(),
      organisation: fetchOrganisation(),
      item,
    });
  }),
  withPropsOnChange(["t"], ({ t }) => ({
    periods: range(1, 11 + 1).map((i) => ({ label: i, value: i })),
    timeframes: [
      ["MONTH", t("Month")],
      ["QUARTER", t("Quarter")],
      ["YEAR", t("Year")],
    ].map(([value, label]) => ({ label, value })),
  })),
  withHandlers({
    handleSubmit:
      ({ setState, xero, dispatch, setReportParams }) =>
      (item) => {
        setReportParams(item);
        return loadReport(
          {
            ...item,
            tracking_category:
              item.compare !== "periods" ? item.compare : undefined,
          },
          xero
        )
          .then((data) => { setState({ data });refreshChart();})
          .finally(() => dispatch(actions.setSubmitted("local", true)));
      },
  })
);

export default enhance(ProfitAndLoss);
